/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/dome_industries': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-13.559-.77l3.405-3.406a8.02 8.02 0 015.065 3.419l-4.229 4.229c-.586.586-1.354.879-2.121.879s-1.535-.293-2.121-.879a3.001 3.001 0 01.001-4.242zM4.75 27.25v-7.086l7.086 7.086H4.75zm0-15.414V4.75h7.086L4.75 11.836zm14.896 9.866l-1.578 1.592-.711-.704 1.229-1.238L17.247 20h-2.479l-1.351 1.352 1.238 1.236-.707.707-1.592-1.591a.503.503 0 010-.708L14 19.354l.354-.354H15v-1.9c.5.188 1.391.269 2 .08V19H17.664l.336.338 1.646 1.66a.502.502 0 010 .704zm7.604 5.548h-7.086l7.086-7.086v7.086zm0-15.414L20.164 4.75h7.086v7.086z"/><circle pid="1" cx="16" cy="14" r="1"/>'
  }
})
